export default "__VITE_ASSET__BbBtDIMW__"